import { Block } from "baseui/block";
import { IAggregate } from "./types";
import { ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { Button } from "baseui/button";
import { ParagraphXSmall } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { useSetObjectValue } from "../../../hooks/useSetObjectValue";
import { themedUseStyletron } from "../../../theme/customTheme";
import TimeAgo from 'react-timeago'
import { IoCalendarOutline } from 'react-icons/io5';
import { useTimeAgoFormatter } from "../../../hooks/useTimeAgoFormatter";

export const OperationHours = (props: IAggregate) => {
    const [css, theme] = themedUseStyletron();
    const [reset, setReset] = useSetObjectValue(props.id, props.resourceGroupId, "operationHoursReset", props.operationHoursReset);
    const { formatter } = useTimeAgoFormatter();

    return (
        <Block>
            <Block alignSelf='flex-start' display={'flex'} gridGap={theme.sizing.scale500} alignItems='baseline'>
                <ValueDisplayWithLabel value={props.operationHours} label={<FormattedMessage id="Devices.OperatingHours" defaultMessage="Operating Hours" />} dimension='h'></ValueDisplayWithLabel>
                <Button size='mini' kind="tertiary" onClick={() => setReset(true)} disabled={props.operationHours === 0 || reset || setReset.isLoading}>
                    <FormattedMessage id="OperationHoursCounter.Reset" defaultMessage="Reset" />
                </Button>
            </Block>
            {props.operationHoursResetTime &&
                <ParagraphXSmall color={theme.colors.contentTertiary}>
                    <FormattedMessage id="OperationHoursCounter.LastReset" defaultMessage={"last reset"}></FormattedMessage>{' '}
                    <IoCalendarOutline></IoCalendarOutline>{' '}<TimeAgo date={props.operationHoursResetTime} formatter={formatter}></TimeAgo>
                </ParagraphXSmall>
            }
        </Block>)
}